import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/task-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/task-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/task-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .post(`/api/v1/task-profiles/${id}/update`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const updateColumnValue = (id, data) => {
  return httpClient
    .put(`/api/v1/task-profiles/${id}/update-column-values`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/task-profiles/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/v1/task-profiles/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const preview = id => {
  return httpClient
    .get(`/api/v1/task-profiles/${id}/previews`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const addAttachments = (id, data, config) => {
  return httpClient
    .post(`/api/v1/task-profiles/${id}/add-attachments`, data, config)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const removeAttachments = (id, fileName) => {
  return httpClient
    .put(`/api/v1/task-profiles/${id}/${fileName}/remove-attachments`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const history = (Options = {}) => {
  return httpClient
    .get('/api/v1/task-profiles/histories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const report = (id, data) => {
  return httpClient
    .post(`/api/v1/task-profiles/${id}/material-report`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productDetailReport = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/task-profiles/${id}/product-details/reports`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroyProductReport = id => {
  return httpClient
    .delete(`/api/v1/task-profiles/${id}/product-reports`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const updateProductReport = ({ id, data }) => {
  return httpClient
    .put(`/api/v1/task-profiles/${id}/update-product-reports`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const downloadTemplate = data => {
  return httpClient
    .post('/api/v1/task-profiles/download-template', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const importTask = data => {
  return httpClient
    .post('/api/v1/task-profiles/import-tasks', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  preview,
  addAttachments,
  removeAttachments,
  formViewModel,
  updateColumnValue,
  history,
  report,
  productDetailReport,
  destroyProductReport,
  updateProductReport,
  downloadTemplate,
  importTask
}
